import { AfterViewInit, Component, DOCUMENT, ElementRef, Inject, Injector, OnInit, ViewChild } from '@angular/core';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';

import { RouterLink, RouterOutlet } from '@angular/router';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { LayoutRefService } from '@metronic/app/core/_base/layout/services/layout-ref.service';
import { AppConsts } from '@shared/AppConsts';

import { HeaderDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/header.directive';
import { ToggleDirective } from '../../../../../assets/metronic/app/core/_base/layout/directives/toggle.directive';
import { FooterComponent } from '../../footer.component';
import { TopBarMenuComponent } from '../../nav/top-bar-menu.component';
import { TopBarComponent } from '../../topbar.component';
import { Theme2BrandComponent } from './theme2-brand.component';

@Component({
    templateUrl: './theme2-layout.component.html',
    selector: 'theme2-layout',
    imports: [RouterLink, ToggleDirective, HeaderDirective, Theme2BrandComponent, TopBarMenuComponent, TopBarComponent, RouterOutlet, FooterComponent]
})
export class Theme2LayoutComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit {

    @ViewChild('ktHeader', {static: true}) ktHeader: ElementRef;

    constructor(
        injector: Injector,
        private layoutRefService: LayoutRefService,
        _dateTimeService: DateTimeService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector, _dateTimeService);
    }

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    ngOnInit() {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    }

    ngAfterViewInit(): void {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('kt-header-menu-wrapper--on');
        this.document.getElementById('kt_header_menu_wrapper').classList.toggle('kt-header-menu-wrapper--on');
    }

    initStickyHeader(): any {
        let headerEl = KTUtil.get('kt_header');
        let options = {
            offset: {
                desktop: null,
                mobile: null
            },
            minimize: {
                mobile: null,
                desktop: null
            },
            classic: {
                mobile: true,
                desktop: true
            }
        };

        if (KTUtil.attr(headerEl, 'kt-minimize-mobile') === 'minimize') {
            options.minimize.mobile = {};
            options.minimize.mobile.on = 'kt-header--minimize-on';
            options.minimize.mobile.off = 'kt-header--minimize-off';
        } else {
            options.minimize.mobile = false;
        }

        if (KTUtil.attr(headerEl, 'kt-minimize') === 'minimize') {
            options.minimize.desktop = {};
            options.minimize.desktop.on = 'kt-header--minimize-on';
            options.minimize.desktop.off = 'kt-header--minimize-off';
        } else {
            options.minimize.desktop = false;
        }

        if (KTUtil.attr(headerEl, 'kt-minimize-offset')) {
            options.offset.desktop = KTUtil.attr(headerEl, 'kt-minimize-offset');
        }

        if (KTUtil.attr(headerEl, 'kt-minimize-mobile-offset')) {
            options.offset.mobile = KTUtil.attr(headerEl, 'kt-minimize-mobile-offset');
        }

        return new KTHeader('kt_header', options);
    }
}
